import React from "react";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";
import "./EditUser.styles.scss";
import Dropdown from "../../../../GeopgraphyTable/components/ManageModal/Dropdown/Dropdown";
import EscapeOutside from "react-escape-outside";
import RestoreIcon from "@mui/icons-material/Restore";
import BounceLoader from "react-spinners/BounceLoader";

import { normalizeString } from "../../../../GeopgraphyTable/components/utils/normalizeString";
import PasswordAndConfirmPasswordValidation from "./PassWordValidation";
import DateFnsUtils from "@date-io/date-fns";
//import moment from "moment";
import { format } from "date-fns";
import { useNotification } from "../../../../../../Notifications/NotificationProvider";

import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import { Alert } from "@mui/material";
import AxiosClient from "../../../../../../../Network/AxiosClient";
import { verificationTypes } from "../../../../../../Shared/GlobalConfigs";
const tm_types = [
  { id: "MDE", name: "MDE – Merchant Development Executive" },
  { id: "MDM", name: "MDM – Merchant Development Manager" },
  { id: "MAM", name: "MAM – Merchant Acquisition Manager" },
  { id: "MMM", name: "MMM – Merchant Management Manager" },
];
const weekdays = [
  {
    id: "101",
    name: "Sunday",
  },
  {
    id: "102",
    name: "Monday",
  },
  {
    id: "103",
    name: "Tuesday",
  },
  {
    id: "104",
    name: "Wednesday",
  },
  {
    id: "105",
    name: "Thursday",
  },
  {
    id: "106",
    name: "Friday",
  },
  {
    id: "107",
    name: "Saturday",
  },
];
const am_types = [
  { id: "dh_user", name: "Distributor" },
  { id: "operation_manager", name: "Operations manager" },
];

const cs_types = [
  { id: "cs_super_user", name: "CS Super User" },
  { id: "cs_user_layer_1", name: "CS L1" },
  { id: "cs_user_layer_2", name: "CS L2" },
];

const editUserFieldsConfig = [
  { label: "Username", id: "username" },
  { label: "Password", id: "password" },
  { label: "Name", id: "name" },
  { label: "Phone", id: "contact_number" },
  { label: "Father's name", id: "father_name", user: "agency" },
  { label: "Mother's name", id: "mother_name", user: "agency" },
  { label: "Email", id: "email", user: "agency" },
  { label: "bKash number", id: "personal_number", user: "agency" },
];

const geographyFields = {
  regional_manager: { label: "region", id: "regions" },
  area_manager: { label: "area", id: "areas" },
  territory_manager: { label: "territory", id: "territories" },
  agency_user: { label: "agency", id: "agency" },
  cluster_head: { label: "cluster", id: "clusters" },
  cs_super_user: null,
  cs_user_layer_1: null,
  cs_user_layer_2: null,
};

const Modal = ({ handleClose, show, children }) => {
  return (
    <div className={show ? "modal display-block" : "modal display-none"}>
      <EscapeOutside onEscapeOutside={() => {}}>
        <div className="wrapper-modal">
          <section className="modal-main">{children}</section>
        </div>
      </EscapeOutside>
    </div>
  );
};

export default function EditUser({
  userData,
  controlZones,
  controlObject,
  enableEdit,
}) {
  const [editFields, setEditFields] = React.useState(null);
  const [isShowingModal, setShowingModal] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const dispatchNotification = useNotification();

  React.useEffect(() => {
    setEditFields({ ...userData });
  }, [userData]);
  //console.log(userData);

  const postData = () => {
    setLoading(true);
    const postObject = {
      ...editFields,
    };
    ["area", "region", "territory", "agency"].map((key) => {
      if (controlObject["zoneCreate"] !== key) delete postObject[key];
    });

    AxiosClient.put(
      `${process.env.REACT_APP_API_URL}/api/users/api/v1/user`,
      postObject,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
        },
      },
    )
      .then((res) => {
        //console.log(res);
        setLoading(false);

        alert("Data saved");
      })
      .catch((err) => {
        //console.log(err);
        setLoading(false);
      });
  };

  const editUserFields = (e, item) => {
    setEditFields({ ...editFields, [item.id]: e.target.value });
  };

  const editJoinDate = (date) => {
    setEditFields({
      ...editFields,
      joining_date: format(new Date(date), "yyyy-MM-dd"),
    });
  };
  const editBirthDate = (date) => {
    setEditFields({
      ...editFields,
      birth_date: format(new Date(date), "yyyy-MM-dd"),
    });
  };
  const editPassWordFieldFromCallBack = (e) => {
    setEditFields({ ...editFields, password: e });
  };
  const editManagerCategory = (type) => {
    setEditFields({ ...editFields, user_category: type.id });
  };

  const editLeaveDay = (leave) => {
    setEditFields({ ...editFields, leave_day: leave.name });
  };

  const editVerificationType = (type) => {
    setEditFields({ ...editFields, verificationTypes: type.id });
  };

  const restoreData = () => {
    setEditFields({ ...userData });
  };
  const editControlZone = (e) => {
    if (controlObject["id"] === "agency_user")
      setEditFields({
        ...editFields,
        [geographyFieldSelector.label]: [{ ...e }],
      });
    //for single select
    else
      setEditFields({
        ...editFields,
        [geographyFieldSelector.label]: [...e],
      }); //for multi-select
  };

  const hideModal = () => {
    setShowingModal(false);
  };

  const showModal = (e) => {
    e.preventDefault();
    setShowingModal(true);
  };

  const geographyFieldSelector = geographyFields[userData["user_type"]];
  const isSuperUser =
    JSON.parse(localStorage.getItem("currUserType")) === "bkash-super-user"
      ? true
      : false;
  console.log(geographyFieldSelector);
  return (
    <div className="manage-user-container">
      {editFields && !editFields["is_active"] && (
        <div className="activate-overlay"></div>
      )}
      <div className={"edit-user-group"}>
        <form noValidate autoComplete="off" style={{ width: "50%" }}>
          {/* <h2 className="section-header">Credentials</h2> */}
          {userData &&
            editFields &&
            editUserFieldsConfig
              .filter((i) => {
                if (controlObject["id"] === "agency_user") {
                  return true;
                } else if (
                  controlObject["id"] === "cs_user" &&
                  i.id === "email"
                ) {
                  return true;
                } else return !i.user;
              })
              .map((item) => {
                return (
                  <div className="input-group">
                    <label>{item.label}</label>
                    <input
                      value={
                        item.id === "password"
                          ? "**********"
                          : editFields[item.id]
                      }
                      type="text"
                      required="required"
                      onChange={(e) => editUserFields(e, item)}
                      disabled={
                        item.id === "password" || !enableEdit ? true : false
                      }
                      style={{ opacity: enableEdit ? 1 : 0.5 }}
                    />
                    {item.id === "password" && (
                      <button disabled={!enableEdit} onClick={showModal}>
                        Edit
                      </button>
                    )}
                  </div>
                );
              })}
          {editFields && (
            <div className="datepicker">
              <label>Joining Date</label>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  autoOk
                  variant="inline"
                  inputVariant="outlined"
                  label="Joining Date"
                  format="dd/MM/yyyy"
                  value={format(
                    new Date(editFields["joining_date"]),
                    "yyyy-MM-dd",
                  )}
                  InputAdornmentProps={{ position: "start" }}
                  onChange={editJoinDate}
                  disabled={!enableEdit || !isSuperUser}
                />
              </MuiPickersUtilsProvider>
            </div>
          )}

          {editFields && controlObject["id"] === "agency_user" && (
            <div className="datepicker">
              <label>Birth Date</label>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  autoOk
                  variant="inline"
                  inputVariant="outlined"
                  label="Birth Date"
                  format="dd/MM/yyyy"
                  value={format(
                    new Date(editFields["birth_date"]),
                    "yyyy-MM-dd",
                  )}
                  InputAdornmentProps={{ position: "start" }}
                  onChange={editBirthDate}
                  disabled={!enableEdit}
                />
              </MuiPickersUtilsProvider>
            </div>
          )}
        </form>
        {editFields && controlObject["id"] === "cs_user" && (
          <div className="input-group">
            <div style={{ width: 350 }}>
              <Dropdown
                disabled={true}
                className="dd-cmdo"
                title="Support User Type"
                items={cs_types}
                onChange={editManagerCategory}
                style={{ width: 350 }}
                searchable={false}
                //reest={this.props.reset}
                selectionProp={cs_types.find(
                  (item) => item.id === editFields["user_type"],
                )}
              />
            </div>
          </div>
        )}
        {/* {userData &&
        geographyFields.map((item) => {
          return (
            <div className="input-group">
              <label>{item.label}</label>
              <div className="geography-fields">
                {userData[item.id].length > 0 ? (
                  userData[item.id].map((el) => {
                    return <p>{el.name}</p>;
                  })
                ) : (
                  <p className="empty">NA</p>
                )}
              </div>
            </div>
          );
        })} */}
        {geographyFieldSelector && (
          <div className="geography-container">
            {/* <h2 className="section-header">Geography</h2> */}
            <div className="input-group">
              {/* <label>{normalizeString(geographyFieldSelector.label)}</label> */}

              {editFields && (
                <div style={{ width: 350 }}>
                  <Dropdown
                    disabled={!enableEdit}
                    className="dd-cmdo"
                    title={`Select ${geographyFieldSelector.label}`}
                    items={controlZones[geographyFieldSelector.id]}
                    onChange={editControlZone}
                    style={{ width: 350 }}
                    multiselect={
                      controlObject["id"] === "agency_user" ? false : true
                    }
                    //searchable
                    //reest={this.props.reset}
                    selectionProp={editFields[geographyFieldSelector.label]}
                  />
                </div>
              )}
            </div>
            {editFields &&
              (controlObject["id"] === "territory_manager" ||
                controlObject["id"] === "agency_user") && (
                <div className="input-group">
                  <div style={{ width: 350 }}>
                    <Dropdown
                      disabled={!enableEdit}
                      className="dd-cmdo"
                      title={`Select manager type`}
                      items={
                        controlObject["id"] === "territory_manager"
                          ? tm_types
                          : am_types
                      }
                      onChange={editManagerCategory}
                      style={{ width: 350 }}
                      searchable={false}
                      //reest={this.props.reset}
                      selectionProp={
                        controlObject["id"] === "territory_manager"
                          ? tm_types.find(
                              (item) => item.id === editFields["user_category"],
                            )
                          : am_types.find(
                              (item) => item.id === editFields["user_category"],
                            )
                      }
                    />
                  </div>
                </div>
              )}

            {editFields && controlObject["id"] === "agency_user" && (
              <div className="input-group">
                <div style={{ width: 350 }}>
                  <Dropdown
                    className="dd-cmdo"
                    title={`Select Leave day`}
                    items={weekdays}
                    onChange={editLeaveDay}
                    style={{ width: 350 }}
                    searchable={false}
                    //reest={this.props.reset}
                    selectionProp={weekdays.find(
                      (item) => item.name === editFields["leave_day"],
                    )}
                  />
                </div>
              </div>
            )}
            {false && editFields && controlObject["id"] === "agency_user" && (
              <div className="input-group">
                <div style={{ width: 350 }}>
                  <Dropdown
                    disabled={!enableEdit}
                    className="dd-cmdo"
                    title={`Select verification type`}
                    items={verificationTypes}
                    onChange={editVerificationType}
                    style={{ width: 350 }}
                    searchable
                    //reest={this.props.reset}
                    selectionProp={verificationTypes.find(
                      (item) => item.id === editFields["verification_type"],
                    )}
                  />
                </div>
              </div>
            )}
          </div>
        )}
        <Modal show={isShowingModal} handleClose={hideModal}>
          <div className="modal-header">
            <div className="headline">
              <div className="main-headline">Manage password</div>
              <div className="sub-headline" style={{ fontSize: 12 }}>
                Password must be at least 8 charachters long and contain at
                least one upper-case letter ,digit and special charachter
              </div>
            </div>
          </div>
          <PasswordAndConfirmPasswordValidation
            callBack={editPassWordFieldFromCallBack}
            closeModal={hideModal}
          />
        </Modal>
      </div>
      <div className="btn-container">
        {/* <button
          onClick={() =>
            dispatchNotification({
              type: "SUCCESS",
              message: "Successfully Logged In.",
            })
          }
        >
          notifixation
        </button> */}
        <button
          className="button--cancel"
          onClick={restoreData}
          disabled={!enableEdit}
          style={{ opacity: enableEdit ? 1 : 0.6 }}
        >
          {" "}
          <RestoreIcon />
          Restore{" "}
        </button>
        <button
          className={"button--save"}
          // disabled={disabledSave}
          onClick={postData}
          disabled={!enableEdit}
          style={{ opacity: enableEdit ? 1 : 0.6 }}
        >
          {loading ? "Saving" : "Save"}
        </button>
        <BounceLoader
          className="loader"
          color={"#e2136e"}
          size={20}
          loading={loading}
        />
      </div>
    </div>
  );
}
